import React, { useEffect, useRef, useState } from 'react';
import './button.css';
import ColorsMain from '../../colors/ColorsMain';

const BecomeButton = ({ token, userId, contractId, BecomeDataStatysFetch }) => {
    const buttonRef = useRef(null);
    const [scriptLoaded, setScriptLoaded] = useState(false);

    const messageHandler = (event) => {
        try {
            if (event.origin === "https://onboarding.svi.becomedigital.net") {
                const data = JSON.parse(event.data);

                if (data.action === "ID-1::loaded") {
                    console.log("Evento 'become:loaded' detectado");
                }
                if (data.action === "ID-1::userFinishedSdk") {
                    console.log("Evento 'become:userFinishedSdk' detectado");
                    BecomeDataStatysFetch();
                }
                if (data.action === "ID-1::exitedSdk") {
                    console.log("Evento 'become:exitedSdk' detectado");
                }
            }
        } catch (error) {
            console.error("Error al analizar event.data:", error);
        }
    };

    useEffect(() => {

        if (!document.querySelector('script[src="https://onboarding.svi.becomedigital.net/resources/button.js"]')) {
            console.log("Agregando script de Become");

            const script = document.createElement('script');
            script.src = "https://onboarding.svi.becomedigital.net/resources/button.js" + "?timestamp=" + new Date().getTime();
            script.async = true;
            document.body.appendChild(script);

            script.onload = () => {
                console.log("Script Become cargado");
                setScriptLoaded(true);
            };

            script.onerror = () => {
                console.error("Error al cargar el script Become.");
            };
        } else {
            console.log("Script de Become ya estaba cargado");
            setScriptLoaded(true);
        }

        window.addEventListener("message", messageHandler);

        return () => {
            window.removeEventListener("message", messageHandler);
        };
    }, []);

    useEffect(() => {
        // Verificar si el elemento personalizado ya está registrado
        if (!customElements.get('become-spinner')) {
            console.log("Registrando 'become-spinner'.");
        } else {
            console.log("'become-spinner' ya está registrado.");
        }
    }, []);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'end' }}>
            <div
                className="border-white rounded-xl"
                style={{
                    paddingRight: 5,
                    paddingLeft: 2,
                    borderRightWidth: 1,
                    borderTopWidth: 1,
                    borderBottomWidth: 1,
                    boxSizing: "border-box",
                }}
            >
                <become-button
                    ref={buttonRef}
                    token={token}
                    userId={userId}
                    contractId={contractId}
                    color={`${ColorsMain.bgLayout}`}
                    language="es"
                    id="become-button"
                    style={{ boxShadow: 'none', cursor: 'pointer', color: '#000' }}
                ></become-button>
            </div>
        </div>
    );
};

export default BecomeButton;
